import { ReportInterface } from '../../../interfaces/report.interface';

export class LoadReportsSuccess {
    public static readonly type = '[JobsPlacements] Load reports success';

    constructor(public reports: Array<ReportInterface>) { }
}
